import React from 'react';
const stats: Array<{
  value: string;
  label: string;
}> = [{
  value: '6',
  label: 'Modules Complets'
}, {
  value: '1 + 5',
  label: 'Système & Bonus'
}, {
  value: 'Pro',
  label: 'Niveau Professionnel'
}, {
  value: '100%',
  label: 'Accès Numérique'
}];
export function StatsStrip() {
  return <section className="bg-petrol-dark px-4 py-6 sm:px-6" data-id="element-204" data-mp="7gh0nlvsu9j9">
      <div className="mx-auto max-w-6xl" data-id="element-205" data-mp="7j371i6yeizw">
        <h2 className="text-center font-display text-[11px] font-bold uppercase tracking-[0.18em] text-gold sm:text-xs" data-id="element-206" data-mp="v61mqdn91mwr">
          Conçu pour les orthophonistes qui veulent tout centraliser
        </h2>
        <dl className="mt-4 grid grid-cols-2 gap-px overflow-hidden rounded-xl bg-white/10 sm:grid-cols-4" data-id="element-207" data-mp="lhjoa32fzrwa">
          {stats.map(stat => <div key={stat.label} className="bg-petrol px-3 py-4 text-center" data-id="element-208" data-mp="qe0dl0ldocay">
              <dt className="sr-only" data-id="element-209" data-mp="1e4nn1qaxz9zm">{stat.label}</dt>
              <dd data-id="element-210" data-mp="1ivvw2l8d0tc9">
                <span className="block font-display text-2xl font-extrabold uppercase text-gold sm:text-3xl" data-id="element-211" data-mp="1iwfcfxid39o6">
                  {stat.value}
                </span>
                <span className="mt-0.5 block font-display text-[10px] font-bold uppercase tracking-widest text-white/80 sm:text-[11px]" data-id="element-212" data-mp="2pdmhuf54nn7h">
                  {stat.label}
                </span>
              </dd>
            </div>)}
        </dl>
      </div>
    </section>;
}